<style lang="scss" scoped>
.mainContainer {
  min-height: 100%;
  //   width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  padding-bottom: 60px;
  box-sizing: border-box;
  position: relative;
}
</style>
<template>
  <div class="mainContainer">
    <base-nav-my-exam></base-nav-my-exam>
    <router-view></router-view>
    <base-footer></base-footer>
  </div>
</template>
<script>
import BaseNavMyExam from '@/components/BaseNavMyExam.vue';
import BaseFooter from '@/components/BaseFooter.vue';

export default {
  componentName: 'UserComponent',
  data() {
    return {};
  },
  methods: {},
  components: {
    BaseNavMyExam,
    BaseFooter,
  },
  created() {},
  mounted() {},
  props: {},
  watch: {},
};
</script>
